import { fetchAcademyApi } from '../../services/academy-api'

export const fetchHeaderApi = async (language, version) => fetchAcademyApi(`/academy/header/${language}/${version}`)



// WEBPACK FOOTER //
// ./src/containers/Header/services.js